import { openErrorDialog, } from 'console/dialogs/error/redux/actions';
import * as deepExtend from 'deep-extend';
import { isMobileApp } from 'utils';
import { ObjectStorage } from 'console/shared/api/object-storage';
export const stop_loading_account_dialog = () => ({
    type: 'STOP_LOADING_ACCOUNT_DIALOG',
});
export const clear_error_account_dialog = () => ({
    type: 'CLEAR_ERROR_ACCOUNT_DIALOG',
});
export const updateAccountFromServer = (account) => ({
    type: 'UPDATE_ACCOUNT__OK',
    update: account,
});
export function update_account(updater, current_password, reload_after) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: 'UPDATE_ACCOUNT__REQUEST' });
        if ('guest_password_set' in updater && !updater.guest_password_set) {
            updater = {
                ...updater,
                // @ts-ignore
                guest_password: null,
            };
        }
        try {
            const { account } = await api.update_account(updater, getState().account.username, current_password);
            dispatch(updateAccountFromServer(account));
            if (reload_after) {
                setTimeout(() => window.location.reload(), 1e3);
            }
        }
        catch (error) {
            const { json } = error;
            let message;
            if (json) {
                if (json?.error === 'authorative_required') {
                    message = 'Указан неправильный текущий пароль';
                }
                else {
                    if (typeof json.error_ui === 'string') {
                        message = json.error_ui;
                    }
                    else if (typeof json.error_ui === 'object')
                        message = json.error_ui;
                    else
                        message = 'Не удалось сохранить настройки';
                }
            }
            else {
                message = 'Ошибка связи с сервером, Настройки не сохранены';
            }
            dispatch({ type: 'UPDATE_ACCOUNT__FAIL', error: message });
            throw error;
        }
    };
}
let ui_setter = {};
const save = async (api) => {
    if (isMobileApp()) {
        const current = ObjectStorage.get(window.localStorage, 'ui_settings') ?? {};
        ObjectStorage.set(window.localStorage, 'ui_settings', deepExtend(current, ui_setter));
    }
    else {
        await api.set_ui_settings(ui_setter);
    }
    ui_setter = {};
};
export const save_ui_settings = (setter) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'SAVE_UI_SETTINGS__REQUEST', setter });
    const state = getState();
    if (!state.account.is_demo && !state.account.is_guest) {
        try {
            deepExtend(ui_setter, setter);
            await save(api);
            dispatch({ type: 'SAVE_UI_SETTINGS__OK', setter });
            dispatch({ type: 'SET_UI_SETTINGS', setter });
        }
        catch (error) {
            const { json } = error;
            let message;
            if (json) {
                if (json?.error === 'authorative_required') {
                    message = 'Указан неправильный текущий пароль';
                }
                else {
                    if (typeof json.error_ui === 'string') {
                        message = json.error_ui;
                    }
                    else if (typeof json.error_ui === 'object')
                        message = json.error_ui;
                    else
                        message = 'Не удалось сохранить настройки';
                }
            }
            else {
                message = 'Ошибка связи с сервером, Настройки не сохранены';
            }
            dispatch({ type: 'SAVE_UI_SETTINGS__FAIL', error: message });
            throw error;
        }
    }
};
export function delete_account(current_password) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: 'DELETE_ACCOUNT__REQUEST' });
        try {
            await api.delete_account(getState().account.username, current_password);
            dispatch({
                type: 'DELETE_ACCOUNT__OK',
            });
        }
        catch (error) {
            const { json } = error;
            let message;
            if (json) {
                if (json?.error === 'authorative_required') {
                    message = 'Указан неправильный текущий пароль';
                }
                else {
                    if (typeof json.error_ui === 'string') {
                        message = json.error_ui;
                    }
                    else if (typeof json.error_ui === 'object')
                        message = json.error_ui;
                    else
                        message = 'Не удалось удалить аккаунт';
                }
            }
            else {
                message = 'Ошибка связи с сервером, удалить не получилось';
            }
            dispatch({ type: 'DELETE_ACCOUNT__FAIL', error: message });
            dispatch(openErrorDialog({ error_ui: message }));
        }
    };
}
